import api from "./api";

const idempotencyKey = () =>
  "afip-" + Date.now() + "-" + Math.random().toString(16).slice(2);

const withIdempotency = (headers = {}) => ({
  headers: {
    ...headers,
    "Idempotency-Key": idempotencyKey(),
  },
});

export const afipService = {
  getReadiness() {
    return api.get("/afip/readiness");
  },
  getCaeaReadiness() {
    return api.get("/afip/caea/readiness");
  },
  listCaeaAuthorizations() {
    return api.get("/afip/caea");
  },
  listCertificates() {
    return api.get("/afip/certificates");
  },
  createCertificate(payload) {
    return api.post("/afip/certificates", payload, withIdempotency());
  },
  uploadCertificate(id, payload) {
    return api.post(`/afip/certificates/${id}/upload`, payload, withIdempotency());
  },
  listConnections() {
    return api.get("/afip/connections");
  },
  refreshConnection(payload) {
    return api.post("/afip/connections/refresh", payload, withIdempotency());
  },
  getLastNumber(params) {
    return api.get("/afip/wsfe/last-number", { params });
  },
  authorizeTest(payload) {
    return api.post("/afip/wsfe/authorize-test", payload);
  },
  listCompanyConfigs() {
    return api.get("/afip/company-configs");
  },
  listConfigs() {
    return api.get("/afip/company-configs");
  },
  updateCompanyConfig(id, payload) {
    return api.patch(`/afip/company-configs/${id}`, payload, withIdempotency());
  },
  reconcileInvoice(id, payload = {}) {
    return api.post(`/afip/invoices/${id}/reconcile`, payload, withIdempotency());
  },
};
